import { useEffect, useRef, useState } from 'react'
import { Button } from "../components/Elements";
import Filters from '../components/UserLists/Filters';
import { NavLink, useNavigate } from 'react-router-dom';
import UserTable from '../components/UserLists/UserTable';
import { getNavigationUrl } from '../../common/helpers/navigationHelpers';
import PageTitle from '../components/PageTitle';
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts';
import { buttonTexts } from '../../constants/texts/buttonTexts';
import { exportExcelHelper } from '../../common/helpers/exportExcelHelper';
import { useSelector } from 'react-redux';
import { UserOperationTypes } from '../../common/types/AuthorizationProps';
import { usePermissionCheck } from '../../hooks/usePermissionCheck';

const UserList = () => {

  usePermissionCheck(UserOperationTypes["Kullanıcı İşlemleri"], "Kullanıcı İşlemleri izni yok");
  const formFilterRef = useRef<HTMLDivElement | null>(null);
  const tableSelectedRows = useRef<any>();


  const [filtersIsOpen, setFiltersIsOpen] = useState<boolean>(true);
  const [excelLoading, setExcelLoading] = useState<boolean>(false);
  const [headCells, setHeadCells] = useState<any[]>([])

  const { userList } = useSelector((state: any) => state.userList);

  // let userCreateAndUpdateUrl = "/kullanici-ekle";
  // userCreateAndUpdateUrl = getNavigationUrl(userCreateAndUpdateUrl);


  const handleHeadCells = (values: any) => {
    setHeadCells(values);
  }

  const exportToExcelClick = async () => {
    setExcelLoading(true);
    try {
      exportExcelHelper(userList, "userId", tableSelectedRows, headCells, "Kullanıcı_Listesi");
    } catch (error) {

    } finally {
      setExcelLoading(false);
    }
  };

  return (
    <div className='w-full'>
      <PageTitle title={pageTitleTexts.userList} />
      <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/kullanicilar-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Kullanıcı Listesi
          </span>
        </div>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>

      <Filters ref={formFilterRef} isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} />
      <div className='flex flex-row-reverse pr-4 space-x-3 space-x-reverse' >
        <NavLink to={getNavigationUrl("/kullanici-ekle")}>
          <Button
            size="xs"
            hover="primary"
            color="primary"
            callback={() => { }}
          >
            <img src="/icons/plus-white.svg" alt="add" />
            <span className='ml-3 mr-3'>Yeni Kullanıcı</span>
          </Button>
        </NavLink>
        <Button
          color="gray"
          hover="gray"
          size="xs"
          callback={() => exportToExcelClick()}
          loading={excelLoading}
          disabled={excelLoading}
        >
          <img src="/icons/download-blue.svg" alt="pushToExcel" />
          <span className='ml-3'>{buttonTexts.exportToExcel}</span>
        </Button>
      </div>
      <UserTable formFilterRef={formFilterRef} tableSelectedRows={tableSelectedRows} getHeadCells={handleHeadCells} ></UserTable>
    </div>
  )
}

export default UserList;